import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const ContentHtmlPackageLoadable = loadable(
  () => import('./ContentHtmlPackage'),
  {
    resolveComponent: components => components.ContentHtmlPackage
  }
);

export const ContentHtmlPackage = WithLazyHydration(
  ContentHtmlPackageLoadable,
  {
    name: 'ContentHtmlPackage'
  }
);
